import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'spassu-code',
});

export const activityDetailRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-detail',
  parent: rootRouteRef,
  path: '/:activityId',
});
